if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	$('.header__burger-lines').click(function(event) {
		$(".header").toggleClass('open-menu');
		$(".burger").slideToggle();
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

	$('.team-slides').slick({
        accessibility: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		rtl: langSelected == 'ar' ? true : false,
		dots: false,
		adaptiveHeight: true,
		responsive: [
			{
			  breakpoint: 1200,
			  settings: {
				slidesToShow: 2,
				rtl: langSelected == 'ar' ? true : false,
				variableWidth: false,
				centerMode: false,
				infinite: true,
			  }
			},
			{
				breakpoint: 700,
				settings: {
				  slidesToShow: 1,
				  rtl: langSelected == 'ar' ? true : false,
				  variableWidth: false,
				  adaptiveHeight: true,
				  infinite: true,
				}
			}
		]
    });
	$('.wellbeing-videos__previews').slick({
        accessibility: true,
		autoplaySpeed: 8000,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		rtl: langSelected == 'ar' ? true : false,
		arrows: true,
		dots: false,
		appendArrows: '.wellbeing-videos__nav',
		responsive: [
			{
				breakpoint: 700,
				settings: {
				  slidesToShow: 2,
				}
			}
		]
    });


	$('.gallery-block__firstrow').slick({
        accessibility: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		rtl: langSelected == 'ar' ? true : false,
		arrows: true,
		variableWidth: true,
		asNavFor: '.gallery-slide',
		responsive: [
			{
				breakpoint: 1100,
				settings: {
				  slidesToShow: 2,
				  variableWidth: false
				}
			},
			{
				breakpoint: 700,
				settings: {
				  slidesToShow: 1,
				  variableWidth: false
				}
			}
		]
    });

	$('.gallery-block__secondrow').slick({
        accessibility: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		rtl: langSelected == 'ar' ? true : false,
		arrows: false,
		variableWidth: true,
		asNavFor: '.gallery-slide',
		responsive: [
			{
				breakpoint: 1100,
				settings: {
				  slidesToShow: 2,
				  variableWidth: false
				}
			},
			{
				breakpoint: 700,
				settings: {
				  slidesToShow: 1,
				  variableWidth: false
				}
			}
		]
    });

	// $('.gallery-block__secondrow').slick({
    //     accessibility: true,
	// 	infinite: true,
	// 	speed: 300,
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	dots: false
    // });

	$(".scroll-down").click(function (){
		$('html, body').animate({
			scrollTop: $(".intro").offset().top
		}, 1000);
	});

	$(".ftscs-slider-config").slick({
        accessibility: true,
		infinite: true,
		fade:true,
		speed: 300,
		// slidesToShow: 1,
		// slidesToScroll: 1,
		arrows: true,
		rtl: langSelected == 'ar' ? true : false,
		pauseOnHover: false,
		autoplaySpeed: 8000,
		autoplay: true,
		dots: false,
		responsive: [
			{
				breakpoint: 700,
				settings: {
					adaptiveHeight: true
				}
			}
		]
    });

	//Dropdown language

	const selected = document.querySelector(".drop-down .selected a")
	
	if( selected ){
		const ulDropwdown = document.querySelector(".drop-down .options ul")

		selected.addEventListener('click' , (e)=>{
			e.preventDefault()
			ulDropwdown.classList.toggle('open')
		})
	
		document.querySelectorAll(".drop-down .options ul li a").forEach((elm) =>{
			elm.addEventListener('click' , function(e){
				e.preventDefault()
				// let text = this.textContent
				// selected.innerHTML = text
				ulDropwdown.classList.remove('open')
			})
		})
	}



	let navbar = document.getElementById("stickyHeaderMenus");
	let sticky = null;
	if(navbar){
		// sticky = navbar.offsetTop;
		sticky = window.pageYOffset + navbar.getBoundingClientRect().top - 120
		console.log("sh sticky" , sticky)

	}
    
    window.addEventListener('scroll', function(){
        scrollW();
	
    })

	window.onscroll = function() {stickyMenu()};

	function stickyMenu(){
		if(navbar){
			if (window.pageYOffset >= sticky) {
				navbar.classList.add("sticky")
			} else {
				navbar.classList.remove("sticky");
			}
		}
	}

	subNavigationFunctionality()

})();


function scrollW(){
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*1){
			animatedEl[i].classList.add('fade-in');
			animatedEl[i].classList.remove('fade-out');
		} else {

			animatedEl[i].classList.remove('fade-in');
			animatedEl[i].classList.add('fade-out');
		}
	}

}

function subNavigationFunctionality(){
	const navItems = document.querySelectorAll('#privary-navigation > li > a')

	navItems.forEach((item) => {
		item.addEventListener('click' , function(e){
			console.log("item..." , item)
			if(this.nextElementSibling){
				e.preventDefault()
				this.nextElementSibling.classList.toggle('open-submenu')
				this.parentElement.classList.toggle('open-submenu')
			}
		})
	})
}

Date.prototype.addHours= function(h){
    this.setHours(this.getHours()+h);
    return this;
}

// Check if a client has the param &referral=menus in the URL 
// or If the data exists in the local storage and is not expired
function checkIfExistReferral(){

	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);
	const queryParam = params.get('referral')
	
	if( queryParam === 'none' ){
		localStorage.removeItem('menus')
		localStorage.removeItem('share')
		return false;
	}

    const pathname = window.location.pathname; // Get the pathname from the URL
    const segments = pathname.split('/'); // Split the pathname into segments
    const lastSlug = segments.filter(Boolean).pop();

    if( '077750'==lastSlug  && localStorage.getItem("disable_price") === null ){
        console.log('Disabled Prices');
        let date  =  new Date();
        if(is_live == "1"){
            date.addHours(1);
        }else{
            date.setMinutes(date.getMinutes() + 5); // timestamp
            date = new Date(date); // Date object   
        }
        localStorage.setItem("disable_price", JSON.stringify({ expired: date }));
        localStorage.removeItem("menus");
    }

	if( localStorage.getItem('menus') ){
		const { expired } = JSON.parse( localStorage.getItem('menus') )
		console.log("@+" , new Date(expired) , new Date())
		if(  new Date() > new Date(expired)  ){
			localStorage.removeItem('menus')
		}else{
			return true
		}
	}

	if( queryParam === 'menus' ){
		const date = is_live  == '1' ? new Date().addHours(1) : new Date(); 
		localStorage.setItem('menus' , JSON.stringify({ expired: date }))
		return true
	}

	return false
	
}

function listenChangeLanguage(){
	$(".drop-down .options a").click(function (e) {
		e.preventDefault();
		let langSel = this.dataset.value
		let pathname = document.location.pathname;
		let origin = document.location.origin;
		let langs = [
			"es",
			"fr",
			"de",
			"pt",
			"it",
			"ko",
			"ja",
			"ru",
			"nl",
			"zh-CN",
		];
		for (const key in langs) {
			if (pathname.indexOf(`/${langs[key]}/`) > -1)
			pathname = pathname.replace(`/${langs[key]}/`, "");
		}

		if (langSel != "en") {
			if ($("body").attr("id") === "home")
			document.location = origin + "/" + langSel;
			else {
			let newUrl = langSel + "/" + pathname;
			newUrl = newUrl.replace("//", "/");
			document.location = origin + "/" + newUrl;
			}
		} else {
			if ($("body").attr("id") === "home") document.location = origin + "/";
			else document.location = origin + "/" + pathname;
		}
	});
}

function checkShareLocalStore(removeBurgerLines = false){
	if(removeBurgerLines){
		document.querySelector('.header__burger-lines').classList.remove('hidden')
	}
	const params = new URLSearchParams(window.location.search);
	const queryParam = params.get('share')
	//localStorage.getItem('share').indexOf(queryParam)>-1
	if( queryParam ){
		if(queryParam.length>0){
			getShareAndDisableNavigation(queryParam)
		}else{
			console.log('Else',localStorage.getItem('share').indexOf(queryParam));
		}
	}else{
		
		if(localStorage.getItem('share')!==null){
			const {value,expired} = JSON.parse( localStorage.getItem('share') )
			if(new Date()>new Date(expired)){
				console.log('Expired')
				localStorage.removeItem('share')
			}else{
				getShareAndDisableNavigation(value.split('|')[0])
			}
		}
	}

}

function getShareAndDisableNavigation(shareKey){
	const date = is_live  == '1' ? new Date().addHours(1) : new Date();
	const req = new FormData();
	req.append( 'operation', 'getShare' );
	req.append( 'shareKey', shareKey);
	fetch(`${site_url}ajax/functions.php`, { method: 'POST', body: req })
	.then( (resp) => resp.json() )
	.then( (data) => {
		localStorage.setItem('share' , JSON.stringify({ value:`${shareKey}|${data.disabled_nav}`,expired: date }));
		if(data.disabled_nav==1){
			document.querySelector('.header__burger-lines').classList.add('hidden')
			document.querySelector('.header__brand-logo').href = "#"
		}
	});
}

//If exist referral=menus we'll hide the burger navigation and remove the href of the logo
function middlewareReferall(){
	if(  !checkIfExistReferral() ){
		document.querySelector('.header__burger-lines').classList.remove('hidden')
	}else{
		document.querySelector('.header__brand-logo').href = "#"
	}

	checkShareLocalStore() 
}

middlewareReferall();
listenChangeLanguage();
